var map = {
	"./bandita-packetgrup.jpg": "920a",
	"./bloc-inici-consumibles.jpg": "a519",
	"./bobines-foam-packetgrup.jpg": "5240",
	"./bosses-aire.jpg": "9f23",
	"./bosses-grip.jpg": "abec",
	"./bosses-minigrip.jpg": "893c",
	"./cantonera-foam-reciclada.jpg": "bdc4",
	"./cantoneres-FOAM.jpg": "32a4",
	"./cantoneres-cartro.jpg": "13af",
	"./carro-portaflejes.jpg": "560e",
	"./carton-ondulado.jpg": "f4e7",
	"./cartro-ondulat.jpg": "0ce1",
	"./cinta-adhesiva-packetgrup.jpg": "e44e",
	"./cintes-KRAFT.jpg": "dc74",
	"./cintes-adhesives-packetgrup.jpg": "3ec5",
	"./cintes-adhesives.jpg": "415e",
	"./cintes-creppe.jpg": "1ce8",
	"./cintes-personalitzades-2.jpg": "7087",
	"./cintes-personalitzades.jpg": "24c5",
	"./cintes-personalitzadess.jpg": "a07f",
	"./cintes-ribbon.jpg": "11e8",
	"./cintes-tramades.jpg": "a007",
	"./cubre-palet.jpg": "85c2",
	"./enfardadora-02.jpg": "72ae",
	"./enfardadora.jpg": "ec5e",
	"./enfardadores-02.jpg": "282a",
	"./enfardadores-papercartro.jpg": "1ad8",
	"./etiquetes-adhesives.jpg": "1b43",
	"./etiquetes-adr.jpg": "e283",
	"./farciment-paper.jpg": "5c45",
	"./farciment-porex.jpg": "5a23",
	"./film-estirable-5.jpg": "1e6b",
	"./film-estirable-automatic.jpg": "605a",
	"./film-estirable.jpg": "bf1b",
	"./film-preestirat-packetgrup.jpg": "9312",
	"./film-preestirat.jpg": "aa90",
	"./flejes-packetgrup.jpg": "ed5f",
	"./flexadora-02.jpg": "f570",
	"./flexadora-manual.jpg": "957f",
	"./flexadora.jpg": "0dcd",
	"./funda-palet.jpg": "596d",
	"./lamina-packetgrup.jpg": "011c",
	"./maquina-enfardadora-packetgrup.jpg": "5670",
	"./maquina-palets-packetgrup.jpg": "ddee",
	"./palespan-biodegradable-02.jpg": "5ea5",
	"./palespan-biodegradable.jpg": "b247",
	"./paper-KRAFT.jpg": "71d8",
	"./paper-kraft-packetgrup.jpg": "4202",
	"./plastic-bombolla.jpg": "9327",
	"./precintadora.jpg": "4894",
	"./precintes-seguretat.jpg": "7d9c",
	"./sense-imatge.jpg": "dc54",
	"./sin-imagen.jpg": "3bc0",
	"./sobres-packet-list.jpg": "65ed",
	"./sobres-paper-bombolla.jpg": "74ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34fe";